import React from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";

const EndUserLicenseAgreement = () => {
  ChangeTitle("End-User License Agreement");

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              End-user license agreement
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="">
            <h1 className="mb-[2rem] legal-title-y">
              (EULA) for Using www.gcclawhelp.com and Associated Mobile
              Applications
            </h1>
            <p className="mb-[2rem] w-full legal-para">
              This End-User License Agreement (EULA) is a legally binding
              contract between the end user, herein referred to as the "User"
              (either an individual or a single entity/organization), and GCC
              Law Help regarding the use of its website and its associated
              mobile applications, including Research, Practice, Store, Advisory
              and Academy and Mobile Apps, which collectively encompass the
              "Product."
            </p>
            <p className="mb-[2rem] w-full legal-para">
              Acceptance of Terms: By accessing, installing, copying, or
              otherwise using the Product, the User agrees to be unconditionally
              bound by the terms of this EULA. If the User does not agree to the
              terms of this EULA, he must not use or access the Product
            </p>
            <ol className="pl-[1.5rem] lg:pl-[2.2rem] legal-ol-num-b">
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Grant of License
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help grants the User a revocable, non-exclusive,
                    non-transferable, limited license to access and use the
                    Product solely for his personal or internal business
                    purposes, subject to the terms of this EULA. GCC Law Help
                    reserves all rights not expressly granted herein.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Account Registration and Data Privacy:{" "}
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                     The User must register an account to access specific
                    product features. The User is solely responsible for
                    maintaining the confidentiality of his account information
                    and all activities under their account.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help commits to processing personal data by
                    applicable data protection laws, ensuring the protection and
                    confidentiality of the User's data.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    By using the Product, the User consents to GCC Law Help's
                    use of his data by GCC Law Help's Privacy Policy, including
                    for promotional purposes. The User acknowledges that his
                    rights to cancel the service and request refunds are subject
                    to GCC Law Help's cancellation and refund policies.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Use Restrictions:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    The User agrees not to use the Product beyond the scope of
                    the license granted under this EULA. The User may not
                    sublicense, sell, rent, lease, distribute, copy, modify,
                    reverse engineer, decompile, disassemble, or create
                    derivative works of the Product or otherwise attempt to
                    access the source code.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    The Product may not be used in any manner that could damage,
                    disable, overburden, or impair any GCC Law Help server or
                    the network(s) connected to any GCC Law Help server or
                    interfere with any other party's use and enjoyment of the
                    Product.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Intellectual Property:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                     All rights, title, and interest in and to the Product,
                    including all associated intellectual property rights, are
                    owned by GCC Law Help or its licensors. The User is granted
                    no rights or licenses to the intellectual property of the
                    Product other than the limited license to use the Product as
                    provided under this EULA.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    No part of the information available on the product may be
                    reproduced or copied in any form or by any means graphic,
                    electronic, or mechanical, including printing, photocopying,
                    recording, taping, or information reproduced on any disc,
                    tape perforated media or other information storage device,
                    etc., without the written permission of GCC Law Help. All
                    disputes are subject to{" "}
                    <span className="legal-text-y">Mumbai (India)</span>{" "}
                    jurisdiction only.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Compliance with Laws:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    The User agrees to use the Product in compliance with all
                    applicable laws, regulations, and guidelines.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Termination:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help reserves the right to terminate this EULA and
                    the User's access to the Product at any time and for any
                    reason, including but not limited to a breach of this EULA.
                    Upon termination, the User must immediately cease all use of
                    the Product and destroy all copies, full or partial, of the
                    Product.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Disclaimer and Limitation of Liability:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    Every effort has been made to avoid errors or omissions in
                    the products/subscriptions. Despite this, errors may creep
                    in. Any mistake, error, or discrepancy noted may be brought
                    to our notice, which shall be resolved in the next version.
                    It is reported that GCC Law Help will not be responsible for
                    any damage or loss to anyone of any kind in any manner
                    arising from that place. To avoid doubt, the reader should
                    cross-check the product's facts, laws, and contents with
                    original government publications or notifications.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help makes no warranties or representations
                    regarding the accuracy, contents, or performance of the
                    products. The products are provided for use only to the
                    maximum extent permitted by applicable law. GCC Law Help
                    disclaims all warranties and conditions, either express or
                    implied, including, but not limited to, implied warranties
                    of merchantability, fitness for a particular purpose, and
                    non-infringement.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                    Any claims made by sales literature or salespersons do not
                    constitute warranties. Because of the diversity of hardware
                    and conditions under which the product may be used, GCC Law
                    Help cannot make any warranty of fitness for a particular
                    purpose. Accordingly, it is recommended that the user
                    thoroughly test the product before relying on it. In any
                    event, any liability of GCC Law Help is limited exclusively
                    to a refund of the product's purchase price, if any.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                     GCC Law Help and/or its directors, employees, agents,
                    representatives, and authors make no representations about
                    the suitability, reliability, availability, timeliness, and
                    accuracy of the information, products, services, and related
                    material contained in the product for any purpose. All such
                    information, software, products, services, and related
                    material are provided on an “as is” basis.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                      The material in the product is general/legal information
                    and is not intended to be advice on any particular matter.
                    Subscribers and readers should seek appropriate professional
                    advice before acting based on any information contained
                    herein. GCC Law Help, its directors, employees, agents,
                    representatives, and the authors expressly disclaim any
                    liability to any person, whether a subscriber or not, in
                    respect of anything and of the consequences of anything done
                    or omitted to be done by any such person in reliance upon
                    the contents of this site and associated web pages.
                  </li>
                  <li className="legal-ol-aplha-g-li">
                     GCC Law Help reserves the right to revise and change the
                    product and may or may not notify any person of such changes
                    and revisions.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Updates and Modifications:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help reserves the right, at its sole discretion, to
                    update, modify, or discontinue the Product or any part
                    thereof and to modify this EULA at any time. Continued use
                    of the Product after such changes shall constitute the
                    User's consent.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Governing Law and Jurisdiction:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    This EULA shall be governed by and construed by the laws of
                    India without giving effect to any principles of conflicts
                    of law. The User agrees that any legal action or proceeding
                    between GCC Law Help and the User for any purpose concerning
                    this EULA or the parties' obligations hereunder shall be
                    brought exclusively in the competent courts in{" "}
                    <span className="legal-text-y">Mumbai (India).</span>
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Indemnification:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    The User agrees to indemnify, defend, and hold harmless GCC
                    Law Help, its officers, directors, employees, agents,
                    licensors, suppliers, and any third-party information
                    providers to the Product from and against all losses,
                    expenses, damages, and costs, including reasonable
                    attorneys' fees, resulting from any violation of this EULA
                    or any activity related to the User's account (including
                    negligent or wrongful conduct) by the User or any other
                    person accessing the Product using the User's account.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Severability:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                     If any provision of this EULA is declared invalid or
                    unenforceable, such provision shall be deemed modified to
                    the extent necessary and possible to render it valid and
                    enforceable. In any event, the unenforceability or
                    invalidity of any provision shall not affect any other
                    provision of this EULA, and this EULA shall continue in full
                    force and effect and be construed and enforced as if such
                    provision had not been included or had been modified as
                    above provided, as the case may be.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Waiver:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help's failure to exercise or enforce any right or
                    provision of this EULA does not constitute a waiver of such
                    right or provision.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Entire Agreement:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    This EULA constitutes the entire agreement between the User
                    and GCC Law Help concerning the use of the Product. It
                    supersedes all prior or contemporaneous understandings,
                    agreements, representations, and warranties, written and
                    oral, regarding the Product.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Amendments:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help reserves the right, at its sole discretion, to
                    amend this EULA at any time. Any amendments will be
                    effective immediately upon posting the revised EULA on the
                    Product. The User's continued use of the Product following
                    the changes will constitute the User's acceptance of such
                    changes.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Force Majeure:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    GCC Law Help shall not be liable for any failure to perform
                    its obligations where such failure results from any cause
                    beyond GCC Law Help's reasonable control, including, without
                    limitation, mechanical, electronic, or communications
                    failure or degradation.
                  </li>
                </ol>
              </li>
              <li className="mb-[1.5rem] legal-ol-num-b-li">
                Assignment:
                <ol className="pl-[2em] p-[1rem] legal-ol-aplha-g">
                  <li className="legal-ol-aplha-g-li">
                    The User may not assign or transfer this EULA, by operation
                    of law or otherwise, without GCC Law Help's prior written
                    consent. Any attempt by the User to assign or transfer this
                    EULA without such consent will be null and of no effect. GCC
                    Law Help may assign or transfer this EULA at its sole
                    discretion, without restriction. Subject to the preceding,
                    this EULA will bind and inure to the benefit of the parties,
                    their successors, and permitted assigns.
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default EndUserLicenseAgreement;
